import { __assign, __read, __rest, __spread } from "tslib";
import React, { useRef } from 'react';
import { useComponentRegistry } from '@bem-react/di';
import { cn } from '@bem-react/classname';
import { useForkRef } from '../useForkRef';
import { Portal } from '../Portal';
import { useOverlay } from '../useOverlay';
import './Popup.css';
export var cnPopup = cn('Popup2');
/**
 * Компонент для создания всплывающего окна (попапа).
 * @param {IPopupProps} props
 */
export var Popup = function (_a) {
    var addonAfter = _a.addonAfter, addonBefore = _a.addonBefore, children = _a.children, className = _a.className, direction = _a.direction, hasTail = _a.hasTail, innerRef = _a.innerRef, keepMounted = _a.keepMounted, scope = _a.scope, style = _a.style, tailRef = _a.tailRef, tailSize = _a.tailSize, visible = _a.visible, zIndex = _a.zIndex, disableOverlay = _a.disableOverlay, unstable_onRenderTail = _a.unstable_onRenderTail, onClose = _a.onClose, _b = _a.unstable_essentialRefs, unstable_essentialRefs = _b === void 0 ? [] : _b, onClick = _a.onClick, 
    // Извлекаем свойства, т.к. они не нужны на DOM узле
    // FIXME: https://github.com/bem/bem-react/issues/381
    // @ts-ignore
    _theme = _a.theme, 
    // @ts-ignore
    _view = _a.view, 
    // @ts-ignore
    _nonvisual = _a.nonvisual, props = __rest(_a, ["addonAfter", "addonBefore", "children", "className", "direction", "hasTail", "innerRef", "keepMounted", "scope", "style", "tailRef", "tailSize", "visible", "zIndex", "disableOverlay", "unstable_onRenderTail", "onClose", "unstable_essentialRefs", "onClick", "theme", "view", "nonvisual"]);
    var containerRef = useRef(null);
    var Tail = useComponentRegistry(cnPopup()).Tail;
    useOverlay({
        onClose: onClose,
        visible: !disableOverlay && visible,
        essentialRefs: __spread([containerRef], unstable_essentialRefs),
    });
    return (React.createElement(Portal, { scope: scope, visible: visible, keepMounted: keepMounted },
        React.createElement("div", __assign({}, props, { className: cnPopup({ visible: visible }, [className]), "data-popper-placement": direction, onClick: onClick, ref: useForkRef(containerRef, innerRef), style: __assign(__assign({}, style), { zIndex: zIndex }) }),
            addonBefore,
            typeof children === 'function' ? children({ tailRef: tailRef }) : children,
            addonAfter,
            unstable_onRenderTail &&
                unstable_onRenderTail(React.createElement(Tail, { ref: tailRef, style: { height: tailSize, width: tailSize } })),
            !unstable_onRenderTail && hasTail && (React.createElement(Tail, { ref: tailRef, style: { height: tailSize, width: tailSize } })))));
};
Popup.displayName = cnPopup();
